import { createAction } from '@ngrx/store';

export const fetchLandRegistryOwnershipDone = createAction('[Map/RHP] Fetch LandRegistry Ownership Done');
